'use client';

import { useSelectedLayoutSegment } from 'next/navigation';
import { useLocale } from 'next-intl';
import { useState } from 'react';
import cn from '@/lib/cn';
import { getPathname } from '@/lib/i18n/navigation';
import routing from '@/lib/i18n/routing';

type ValidPathname =
  | '/career'
  | '/company'
  | '/imprint'
  | '/partners'
  | '/press'
  | '/privacy-policy';

export default function LanguageSwitch({
  className = undefined,
}: {
  className?: string;
}) {
  const currentLocale = useLocale();
  const segment = useSelectedLayoutSegment();

  const [isHover, setIsHover] = useState(false);
  const [indicatorX, setIndicatorX] = useState(
    routing.locales.indexOf(currentLocale) * 100,
  );

  function onMouseEnter(index: number) {
    setIsHover(true);
    setIndicatorX(index * 100);
  }

  function onMouseLeave() {
    setIsHover(false);
    setIndicatorX(routing.locales.indexOf(currentLocale) * 100);
  }

  let href: ValidPathname;

  if (Object.keys(routing.pathnames).includes(`/${segment}`)) {
    href = `/${segment}` as ValidPathname;
  } else {
    href = '/company';
  }

  return (
    <div className={className}>
      <nav className="relative isolate inline-block rounded-full border border-white/10 bg-white/10 p-1 font-semibold">
        <ul className="inline-grid grid-cols-3">
          {routing.locales.map((locale, i) => (
            <li key={locale}>
              <a
                className={cn(
                  'block px-3 py-2 transition-colors',
                  locale === currentLocale && !isHover
                    ? 'text-black'
                    : 'text-white',
                )}
                href={getPathname({ href, locale })}
                hrefLang={locale}
                onMouseEnter={
                  locale === currentLocale ? undefined : () => onMouseEnter(i)
                }
                onMouseLeave={
                  locale === currentLocale ? undefined : onMouseLeave
                }
              >
                {locale.toUpperCase()}
              </a>
            </li>
          ))}
        </ul>

        <span
          className={cn(
            'absolute left-1 -z-10 h-[calc(100%-0.5rem)] w-[calc((100%-0.5rem)/3)] rounded-full transition',
            isHover ? 'bg-white/25' : 'bg-white',
          )}
          style={{
            transform: `translateX(${indicatorX}%)`,
          }}
        />
      </nav>
    </div>
  );
}
